import React from 'react'
import { ReactComponent as Dog } from '../img/logo_dog_teal.svg'

export default () => (
    <Dog width="100px" height="100%"/>
)
